import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
  YOTI,
  POST_OFFICE,
  YOTI_WITH_POST_OFFICE,
  DIDC
} from './skins-identifiers'
import { QS_PARAM_NAME } from './query-param-identifiers'
import SkinContext from './SkinContext'
import { getSupportedApps } from './supportedApps'
import { applyTheme } from './applyTheme'
import { logger } from './logger'

const supportedSkins = [
  YOTI,
  POST_OFFICE,
  YOTI_WITH_POST_OFFICE,
  DIDC
]

const defaultSkin = YOTI

const SkinProvider = ({ children }) => {
  const [skinIdentifier, setSkinIdentifier] = useState(new URLSearchParams(window.location.search).get(QS_PARAM_NAME) || defaultSkin)

  useEffect(() => {
    logger.info(`Skin to apply: '${skinIdentifier}'`)
    if (!supportedSkins.includes(skinIdentifier)) {
      logger.warn(`Non supported skin: '${skinIdentifier}'! Using default value '${defaultSkin}' instead.`)
      setSkinIdentifier(defaultSkin)
    } else {
      applyTheme(skinIdentifier)
      logger.info('Skin applied!')
    }
  }, [skinIdentifier])

  const supportedApps = getSupportedApps(skinIdentifier)
  if (!supportedApps.length) {
    logger.warn(`No supported applications for skin: '${skinIdentifier}'!`)
  }

  const context = {
    id: skinIdentifier,
    changeSkin: setSkinIdentifier,
    supportedApps
  }


  return (
    <SkinContext.Provider value={context}>
      {children}
    </SkinContext.Provider>
  )
}

SkinProvider.defaultProps = {
  children: null
}

SkinProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ])
}

export default SkinProvider
